import React from "react";

export interface InputState {
    weekOffset: number;
    modalOpen: boolean;
    isRegular: boolean;
    version: number; // Force re-render
}

export const defaultInputState: InputState = {
    weekOffset: 0,
    modalOpen: false,
    isRegular: true,
    version: 0,
};

const InputStateContext = React.createContext<InputState>(defaultInputState);

export default InputStateContext;
